import { memo } from "react";

export const NoWaveSelectedContent = memo(() => {
  return (
    <>
      To edit a route, please select a wave on the timeline bar first or select
      'Final Routes'
    </>
  );
});
